module.exports = __webpack_public_path__ + "static/img/header.ab1e611.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/es-orange/images/header.jpg
// module id = Mhju
// module chunks = 1